import * as React from 'react';
import createSvgIcon from './utils/createSvgIcon';
export default createSvgIcon( /*#__PURE__*/React.createElement("path", {
  d: "M19 4h-4L7.11 16.63 4.5 12 9 4H5L.5 12 5 20h4l7.89-12.63L19.5 12 15 20h4l4.5-8L19 4z"
}), 'PolymerRounded');


//////////////////
// WEBPACK FOOTER
// ./~/@material-ui/icons/esm/PolymerRounded.js
// module id = 5554
// module chunks = 2